import React from 'react';
import { SlClose } from 'react-icons/sl';

const ModalBox = ({ children, className = '', closeCallback }) => {
    const handleClose = () => {
        closeCallback();
    };

    return (
        <div className='modalbox-overlay'>
            <div className={`modalbox ${className}`}>
                <div className='close-btn-container'>
                    <SlClose onClick={handleClose} size={24} style={{ cursor: 'pointer', strokeWidth: '8' }} />
                </div>
                {children}
            </div>
        </div>
    );
};

export default ModalBox;
